import React from 'react';
import { useQuery } from '@apollo/client';
import {
  Refunds,
  FetchRefundsInPpcQuery,
  FetchRefundsInPpcQueryVariables,
  PartnerSearchContext,
} from '@css-xp/graphtypes/src/generated-types-new';
import { RefundTable } from '@css-xp/ppc-refund-table';
import { fetchRefundsInPPC } from '../../queries/fetch-refunds';

interface RefundSearchProps {
  searchTerm: string;
  transactionAccountId: string;
  partnerSearchContext: string;
  isDesignIteration1Enabled?: boolean;
}

export const RefundSearch = ({
  searchTerm,
  transactionAccountId,
  partnerSearchContext,
  isDesignIteration1Enabled,
}: RefundSearchProps) => {
  const { data, error, loading } = useQuery<FetchRefundsInPpcQuery, FetchRefundsInPpcQueryVariables>(
    fetchRefundsInPPC,
    {
      variables: {
        searchParams: {
          query: searchTerm,
          transactionAccountId,
          partnerSearchContext: partnerSearchContext as PartnerSearchContext,
          isOrgSearchEnabled: true,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    }
  );

  const results = (data?.partnerRefunds?.results || []) as Refunds[];

  return (
    <div data-testid="refund-list" data-test-id="refund-list">
      {
        <RefundTable
          refunds={results}
          transactionAccountId={transactionAccountId}
          isLoading={loading}
          error={error}
          shouldHideCustomiseView={isDesignIteration1Enabled}
          shouldHideInnerHeading={isDesignIteration1Enabled}
          shouldHideFilters={isDesignIteration1Enabled}
          isDesignIteration1Enabled={isDesignIteration1Enabled}
        />
      }
    </div>
  );
};

RefundSearch.displayName = 'RefundSearch';
